<template>
    <div class="flex flex-center-sp">
        <div class="down-body flex flex-col">
            <div class="margin-top-xxl flex flex-center-sp font-xxl font-bold">小程序</div>
            <div class="flex ">
                <div class="app-body margin-right-l  margin-top-xxl  flex flex-col flex-center-cz padding-xl">
                    <img class="margin-top-xxl" style="width: 168px;height: 168px;margin-bottom: 10px;" src="@/assets/images/lzwd_qrcode.jpg"/>
                    <!-- <div class="margin-top-s margin-bottom-xl color-rgb-05">安卓移动端</div> -->
                    <div class="margin-top-xxl btn-blue-line w120 pointer border-radius-xl">扫码使用</div>
                </div>
                <!-- <div class="app-body margin-left-l  margin-top-xxl  flex flex-col flex-center-cz padding-xl">
                    <img class="margin-top-xxl" style="width: 60px;height: 60px;margin-bottom: 10px;" src="@/assets/images/ios.png"/>
                    <div class="margin-top-s margin-bottom-xl color-rgb-05">IOS移动端</div>
                    <div class="margin-top-xxl btn-blue-line w120 pointer border-radius-xl">扫码下载</div>
                </div> -->
            </div>
        </div>
    </div>

</template>

<script >
 export default {
    name:'Down'
 }
    

</script>

<style>
  .down-body {
    margin-top: 60px;
    margin-bottom: 30px;
    min-height: 500px;

  }
  .app-body {
    width: 230px;
    height: 330px;
    background-color: #fff;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  }

  





</style>


// WEBPACK FOOTER //
// src/views/Down.vue